<template>
  <v-dialog v-model="ModalToSIMASN" persistent max-width="40%">
    <v-card>
      <v-card-title class="headline"> Sinkron Data Ke IDASN? </v-card-title>
      <v-card-text>
        Data penghargaan yang anda pilih akan disalin ke data penghargaan di
        IDASN!
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" small depressed @click="ModalToSIMASN = false">
          Batal
        </v-btn>
        <v-btn
          color="primary"
          small
          depressed
          :loading="lbtn"
          :disabled="lbtn"
          @click="toSIMASN()"
        >
          Ya
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";

import modal_tosimasnState from "@/store/asn/rwanak/modal_to_simasn";
import refreshView from "@/store/asn/rwanak/viewRwanak";

export default {
  data: () => ({
    token: Cookie.get("token"),
    lbtn: false,
  }),

  computed: {
    ModalToSIMASN: {
      get() {
        return modal_tosimasnState.state.ModalToSIMASN;
      },

      set(value) {
        modal_tosimasnState.commit("toggleModal", value);
      },
    },

    item: {
      get() {
        return modal_tosimasnState.state.rwanak;
      },
    },

    editedDatautama: {
      get() {
        return modal_tosimasnState.state.dataUtama;
      },
    },
  },

  methods: {
    async toSIMASN() {
      this.lbtn = false;

      let data = {
        NIK: this.item.NIK,
        nama: this.item.nama,
        tempatLahir: this.item.tempatLahir,
        tglLahir: this.item.tglLahir,
        aktaMeninggal: this.item.aktaMeninggal,
        tglMeninggal: this.item.tglMeninggal,
        jenisKelamin: this.item.jenisKelamin,
        ortu: {
          id: this.item.ibuId,
          jenisAnak: this.item.jenisAnak,
        },
      };

      const url = process.env.VUE_APP_ASN + "anak/nip/" + this.$route.params.id;

      this.http
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.lbtn = true;
          if (response.data.success) {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", response.data.message);
            refreshView.commit("berhasilAlert", true);
            refreshView.commit("gagalAlert", false);
            refreshView.commit("success", response.data.success);
          } else {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", response.data.message);
            refreshView.commit("gagalAlert", true);
            refreshView.commit("berhasilAlert", false);
            refreshView.commit("success", response.data.success);
          }
          this.ModalToSIMASN = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            this.lbtn = true;
            console.log(error.response.status);
          } else {
            this.lbtn = true;
            console.log("Error", error.message);
          }
        });
    },
  },
};
</script>
